module.exports = __webpack_public_path__ + "img/1-12.345e2524.png";